
import React, { useState } from 'react'
import { Offcanvas } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';

const Header = () => {

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const naviagte = useNavigate();
    const token = localStorage.getItem('token')
    const adminToken = localStorage.getItem('admintoken')
    const role = localStorage.getItem('role')

    const scrollToElement = (id) => {
        const element = document.getElementById(id);
        element?.scrollIntoView({ behavior: 'smooth' });
    };

    const logout = () => {
        localStorage.clear();
        naviagte('/barbar')
    }

    return (
        <>
            <div className='container'>
                <div class="slider-header px-5">
                    <div class="container">
                        <div class="row">
                            {/* <!--Left Logo header--> */}


                            {/* <!--Navigation - Center Logo header--> */}
                            <div class="header">
                                <div class="mobile-ic" onClick={handleShow}>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>

                                <div class="table-cell">
                                    <ul>
                                        <li class="active"><Link to="/#home" title="Home" onClick={() => scrollToElement('home')}>Home</Link></li>
                                        <li><Link to="/#about" title="Aboutus" onClick={() => scrollToElement('about')}>About us</Link></li>
                                        <li><Link to="/#services" title="Services" onClick={() => scrollToElement('services')}>Services</Link></li>
                                        <li><Link to="/barbars" title="Barbars">Barber</Link></li>
                                    </ul>
                                </div>
                                <div class="logo">
                                    <a href="/barbar" title="Barber Shop"><img src="/assets/images/logo.png" alt="logo" /></a>
                                </div>
                                <div class="table-cell">
                                    <ul>
                                        <li><a href="/#gallery" title="Gallery" onClick={() => scrollToElement('gallery')}>Gallery</a></li>
                                        <li><a href="/#location" title="Location" onClick={() => scrollToElement('location')}>Location</a></li>
                                        {role === 'admin' &&
                                            <>
                                                <li><Link to="/appointment" title="Location" onClick={() => scrollToElement('location')}>Appointment</Link></li>

                                            </>
                                        }
                                        {token || adminToken ?
                                            <>
                                                <li onClick={() => logout()}><Link href="#">Logout</Link></li>
                                            </>
                                            :

                                            <>
                                                {/* <li><a href="/signup" title="Sign Up" >Sign Up</a></li> */}
                                                <li><a href="/login" title="Login" >Login</a></li>
                                            </>
                                        }
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Offcanvas show={show} onHide={handleClose} style={{ backgroundColor: '#d89f46' }}>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>
                        <div class="logo">
                            <a href="/barbar" title="Barber Shop"><img src="/assets/images/logo.png" alt="logo" /></a>
                        </div>
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div class="mobile-cell">
                        <ul>
                            <li class="active"><a href="/#home" title="Home" onClick={() => scrollToElement('home')}>Home</a></li>
                            <li><Link to="/#about" title="Aboutus" onClick={() => scrollToElement('about')}>About us</Link></li>
                            <li><Link to="/#services" title="Services" onClick={() => scrollToElement('services')}>Services</Link></li>
                            <li><Link to="/barbars" title="Barbars">Barber</Link></li>
                            <li><Link to="/#gallery" title="Gallery" onClick={() => scrollToElement('gallery')}>Gallery</Link></li>
                            <li><Link to="/#location" title="Location" onClick={() => scrollToElement('location')}>Location</Link></li>
                            {role === 'admin' &&
                                <>
                                    <li><Link to="/appointment" title="Location" onClick={() => scrollToElement('location')}>Appointment</Link></li>

                                </>
                            }
                            {token || adminToken ?
                                <>
                                    <li><Link href="#" title="Logout" onClick={() => logout()}>Logout</Link></li>
                                </>
                                :

                                <>
                                    {/* <li><a href="/signup" title="Sign Up" >Sign Up</a></li> */}
                                    <li><a href="/login" title="Login" >Login</a></li>
                                </>
                            }
                        </ul>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}

export default Header